import { customFetch, appendFormDataWithObjectValues } from 'utils/http';
import { RefundAmountExceedsTheBalance, HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { m8ErrorMessageMap } from 'services/production/utils/constants';

type Params = {
  idRefund: number;
  amount: number;
  comment: string;
};

export const updateRefund = async (params: Params) => {
  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(getM8AdminURL('updateRefund'), {
    method: 'PUT',
    body,
  });

  if (!response.ok) {
    if (response.status === 400) {
      const data = await response.json();

      if (data.message === m8ErrorMessageMap.AMOUNT_EXCEEDS_THE_BALANCE) {
        throw new RefundAmountExceedsTheBalance();
      }
    }

    throw new HTTPResponseError(response);
  }
};
